import { routes as queueRoutes } from "./queue/routes";
import { routes as currentInpatientRoutes } from "./current-inpatients/routes";
import { routes as pendingDischargeRoutes } from "./pending-discharge/routes";
import { routes as dischargedRoutes } from "./discharged/routes";
import { routes as gatePassRoutes } from "./discharged/prints/routes";
export const routes  = [

    ...queueRoutes(),
    ...currentInpatientRoutes(),
    ...pendingDischargeRoutes(),
    ...dischargedRoutes(),
    ...gatePassRoutes(),
];
